import { useQuery } from '@tanstack/react-query';

import { getAttractionStats } from '~/services/AttractionsService';

import type { GetAttractionStatsParams } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseGetAttractionStatsOptions {
  enabled?: boolean;
}

/**
 * Fetches aggregated attraction stats with optional filters.
 */
export function useGetAttractionStats(
  params: GetAttractionStatsParams = {},
  options: UseGetAttractionStatsOptions = {},
) {
  const { enabled = true } = options;
  return useQuery({
    queryKey: attractionQueryKeys.stats(params as Record<string, unknown>),
    queryFn: async ({ signal }) => {
      return await getAttractionStats(params, { signal });
    },
    enabled,
    retry: false,
  });
}
